module.exports = __webpack_public_path__ + "media/images/top/review-sample03-d5918fc74eb354435e1b38f481ba4417.jpg";